import Cookies from 'js-cookie';
import { lazy } from 'react';

const RETRY_COOKIE_NAME = 'routeRetry';
const RETRY_COOKIE_TTL_IN_MS = 1000 * 60 * 10;
const RETRY_COOKIE_VALUE = '1';

type ComponentImportType = () => Promise<{ default: React.ComponentType }>;

const lazyRetryWrapper = (componentImport: ComponentImportType) =>
  lazy(async () => {
    if (Cookies.get(RETRY_COOKIE_NAME)) {
      return componentImport();
    }
    try {
      return await componentImport();
    } catch (error) {
      Cookies.set(RETRY_COOKIE_NAME, RETRY_COOKIE_VALUE, {
        expires: new Date(new Date().getTime() + RETRY_COOKIE_TTL_IN_MS),
      });

      // @ts-ignore
      window.location.reload(true);
    }
    return componentImport();
  });

export default lazyRetryWrapper;
